import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import '../../../Styles/Organization.css';

class EditOrganizationSAM extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { org, options } = this.props;

        return (
            <div className="settingsSelectOption">
                <h2>Are You Registered in SAM?</h2>
                <p style={{marginTop: 10}}>SAM registration is required to business with the U.S. government. <a href="https://www.sam.gov/SAM/" target="_blank">Register for SAM</a> or <a href="https:/portal.opengrants.io/checkout/registration" target="_blank">let us do it for you</a>.</p>
                <div className="profileSelectOption">
                    <Select 
                        name="saM_Number"
                        isClearable={false}
                        isSearchable={false}
                        defaultValue={org.organization.saM_Number == true ? { label: "Yes", value: true } : { label: "No", value: false }}
                        onChange={(value) => this.props.handleSelectionChange(value, "saM_Number")}
                        options={options}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { setUser, organization, setWhitelabel } = state;
    const { user } = setUser;
    const { whitelabel } = setWhitelabel;

    return {
        user,
        organization,
        whitelabel,
    };
}

const connectedEditOrganizationSAM = connect(mapStateToProps)(EditOrganizationSAM);
export { connectedEditOrganizationSAM as EditOrganizationSAM };